export default __webpack_public_path__ + "static/media/logo_kuery_medio.8683478c.png";